export const USERCONTACT = 'USERCONTACT';
export const SCHEDULETOUR = 'SCHEDULETOUR';
export const WAITLIST = 'WAITLIST';
